import { Container, Grid, Paper, Typography, Box } from '@mui/material'
import SeeNotice from '../../components/SeeNotice';
import CountUp from 'react-countup';
import styled from 'styled-components';
import Students from "../../assets/img1.png";
import Lessons from "../../assets/subjects.svg";
import Tests from "../../assets/assignment.svg";
import Time from "../../assets/time.svg";
import { getClassStudents, getSubjectDetails } from '../../redux/sclassRelated/sclassHandle';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { motion } from 'framer-motion';

const TeacherHomePage = () => {
    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.user);
    const { subjectDetails, sclassStudents } = useSelector((state) => state.sclass);

    const classID = currentUser?.teachSclass?._id
    const subjectID = currentUser?.teachSubject?._id

    useEffect(() => {
        if(classID && subjectID) {
            dispatch(getSubjectDetails(subjectID, "Subject"));
            dispatch(getClassStudents(classID));
        }
    }, [dispatch, subjectID, classID]);

    const numberOfStudents = sclassStudents && sclassStudents.length;
    const numberOfSessions = subjectDetails && subjectDetails.sessions

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.5 }
        }
    };

    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#0A192F' }}>
                        Welcome back, Prof. {currentUser?.name}! 🎓
                    </Typography>
                    <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                        Here is your class overview for today.
                    </Typography>
                </Box>
                
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(255, 153, 51, 0.1)' }}>
                                    <img src={Students} alt="Students" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Class Students</Title>
                                    <Data start={0} end={numberOfStudents || 0} duration={2} />
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(10, 25, 47, 0.05)' }}>
                                    <img src={Lessons} alt="Lessons" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Total Lessons</Title>
                                    <Data start={0} end={numberOfSessions || 0} duration={2} />
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(255, 153, 51, 0.1)' }}>
                                    <img src={Tests} alt="Tests" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Tests Taken</Title>
                                    <Data start={0} end={24} duration={2} />
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(10, 25, 47, 0.05)' }}>
                                    <img src={Time} alt="Time" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Total Hours</Title>
                                    <Data start={0} end={30} duration={2.5} suffix="hrs" />                        
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12}>
                        <motion.div variants={itemVariants}>
                            <Paper elevation={3} sx={{ p: 3, borderRadius: '16px' }}>
                                <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#0A192F' }}>
                                    Department Notices
                                </Typography>
                                <SeeNotice />
                            </Paper>
                        </motion.div>
                    </Grid>
                </Grid>
            </motion.div>
        </Container>
    )
}

const StyledPaper = styled(Paper)`
  padding: 24px;
  display: flex;
  height: 160px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 16px !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(0,0,0,0.1) !important;
  }
`;

const IconWrapper = styled(Box)`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.p`
  font-size: 1.1rem;
  color: #64748B;
  margin: 0;
  font-weight: 500;
`;

const Data = styled(CountUp)`
  font-size: 2rem;
  font-weight: 700;
  color: #0A192F;
  margin-top: 5px;
`;

export default TeacherHomePage